<template>
  <div class="waitforjob">
    <div v-if="actualstep === 5" class="container-final-job">
      <span>{{ $t("portfolio-correctly-uploaded") }}</span>
      <div>
        <button class="brains-type1-btn" @click="closeportfolioupload">{{ $t("portfolio-vis") }}</button>
      </div>
    </div>
    <div v-else class="container-final-job">
      <span>{{ $t('portfolio-uploading') }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'PortfolioWaitJob',
  props: {
    portfolioname: {
      required: true,
      type: String
    }
  },
  computed: {
    ...mapState('portfolio', {
      actualstep: (state) => state.uploadportfolio.actualstep
    })
  },
  methods: {
    async closeportfolioupload() {
      // debugger
      await this.$store.dispatch('portfolio/getUserPortfolios')
      this.$store.dispatch('portfolio/startnewportfolio')
      this.$root.$emit('closeportfolioload')
      this.$root.$emit('openportfolioload')
    }
  }
}
</script>
<style lang="scss" scoped>
.waitforjob {
  width: 100%;
  padding-right: 110px;

  display: flex;
  justify-content: flex-end;

  .container-final-job {
    border: 1px solid #e5af44;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    text-align: center;
    gap: 10px;
    align-items: center;
    height: 200px;
    padding: 10px 30px 15px 30px;
    width: 500px;
    margin-top: 20px;
    font-family: 'Montserrat-Light',sans-serif;
    line-height: 25px;
    font-size: 14px;
  }
}
</style>
